module.exports = __webpack_public_path__ + "static/media/ContasPagRec7.ffdb42c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelContasPagRec/ContasPagRec7.png
// module id = 2016
// module chunks = 0